var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i-youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "footer-quick-link_1024-nomenu",
    transform: "translate(-712.000000, -170.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "social-icons-copy",
    transform: "translate(661.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i-youtube",
    transform: "translate(51.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    stroke: "#FFFFFF",
    opacity: 0.1,
    cx: 19.8665414,
    cy: 20,
    rx: 19.8665414,
    ry: 20
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.231708,17.9284533 C26.231708,17.9284533 26.3552606,18.9572265 26.3552606,19.9856025 L26.3552606,20.9500278 C26.3552606,21.978801 26.231708,23.007177 26.231708,23.007177 C26.231708,23.007177 26.1108581,23.8830245 25.7405864,24.2687151 C25.2707004,24.7751575 24.7440574,24.7775408 24.5027437,24.8073315 C22.7737794,24.9360275 20.1776303,24.9399996 20.1776303,24.9399996 C20.1776303,24.9399996 16.9652625,24.9098116 15.9768417,24.812098 C15.7019371,24.7592691 15.0845602,24.7751575 14.6142881,24.2687151 C14.2440164,23.8830245 14.1235526,23.007177 14.1235526,23.007177 C14.1235526,23.007177 14,21.978801 14,20.9500278 L14,19.9856025 C14,18.9572265 14.1235526,17.9284533 14.1235526,17.9284533 C14.1235526,17.9284533 14.2440164,17.0526058 14.6142881,16.6669152 C15.0845602,16.1604727 15.6108171,16.1580895 15.8525169,16.128696 C17.5814812,16 20.1749276,16 20.1749276,16 L20.180333,16 C20.180333,16 22.7737794,16 24.5027437,16.128696 C24.7440574,16.1580895 25.2707004,16.1604727 25.7405864,16.6669152 C26.1108581,17.0526058 26.231708,17.9284533 26.231708,17.9284533 Z M18.9019496,22.1186188 L22.2398005,20.3391192 L18.9015635,18.5473061 L18.9019496,22.1186188 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.9ed0183d8dc028dff6285e8088975ad2.svg";
export { ForwardRef as ReactComponent };